import React from 'react';
import PropTypes from 'prop-types';
import { FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import { TextField, LookupField } from 'react/components/fields';
import OrganizationTreeView from './OrganizationTreeView';

function GeneralSection({
  organization,
  surveyOrganizations,
  organizationsHierarchy
}) {
  return (
    <FormSection title="Survey.form.generalSection" className="generalSection">
      <FormSectionColumn>
        <TextField
          label="Survey.form.header.description"
          name="description"
          required
        />

        <TextField label="survey.title" name="title" shouldShow={false} />

        <LookupField
          label="survey.organization"
          name="organization"
          lookupEntity="Organization"
          lookupEntityColumn="description"
          shouldShow={false}
        />

        <OrganizationTreeView
          label="Survey.form.header.specificOrganizations"
          name="surveyOrganizations"
          monetMeta={{
            hasMany: {
              entityName: 'organization',
              collectionName: 'surveyOrganizations'
            }
          }}
          fieldCriteria={[
            'surveyOrganizations.id',
            'surveyOrganizations.organization.id'
          ]}
          organizationsHierarchy={organizationsHierarchy}
          surveyOrganizations={surveyOrganizations}
          organization={organization}
          lookupEntity="Organization"
          lookupEntityColumn="description"
          multiple
          required
        />

        <TextField
          label="survey.releasedDate"
          name="releasedDate"
          shouldShow={false}
          gridFormatter={() => ({
            id: 'releasedDate',
            name: 'releasedDate',
            label: 'survey.releasedDate',
            type: 'DATE_TIME'
          })}
        />

        <TextField
          label="survey.closedDate"
          name="closedDate"
          shouldShow={false}
          gridFormatter={() => ({
            id: 'closedDate',
            name: 'closedDate',
            label: 'survey.closedDate',
            type: 'DATE_TIME'
          })}
        />

        <LookupField
          label="survey.userReleased"
          name="userReleased"
          lookupEntity="Users"
          lookupEntityColumn="name"
          shouldShow={false}
          fieldCriteria={['userReleased.*']}
        />

        <LookupField
          label="survey.userClosed"
          name="userClosed"
          lookupEntity="Users"
          lookupEntityColumn="name"
          shouldShow={false}
          fieldCriteria={['userClosed.*']}
        />

        <TextField
          label="surveyApplyRules"
          name="surveyApplyRules"
          doNotShowOnGrid
          shouldShow={false}
          fieldCriteria={['surveyApplyRules.*']}
        />
      </FormSectionColumn>
    </FormSection>
  );
}

GeneralSection.propTypes = {
  organization: PropTypes.object.isRequired,
  surveyOrganizations: PropTypes.object.isRequired,
  organizationsHierarchy: PropTypes.array.isRequired
};

export default GeneralSection;
